import React, { useCallback } from 'react'
import { Alert } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { BulletinAttachment } from '../../../../../../../common/validations'

import { OpenableFileListItem } from 'components/OpenableFileListItem/OpenableFileListItem'
import { useOpenFile } from 'hooks/useOpenFile/useOpenFile'
import { useAPIGetBulletinAttachment } from 'api/apiHooks/useAPIGetBulletinAttachment'

interface AttachmentLinkProps {
  attachment: BulletinAttachment
}

export const AttachmentLink: React.FC<AttachmentLinkProps> = ({
  attachment,
}) => {
  const { refetch: refetchSignedUrl } = useAPIGetBulletinAttachment(
    attachment.uuid
  )

  const getSignedUrl = useCallback(async () => {
    const { data } = await refetchSignedUrl()

    return data?.url
  }, [refetchSignedUrl])

  const { t } = useTranslation(['errors'])
  const { openFile, isOpening, hasOpenError } = useOpenFile(getSignedUrl)

  return (
    <div>
      {hasOpenError && (
        <Alert variant="danger" className="w-full justify-start mb-2">
          {t('errors:other.failedToOpenAttachment')}
        </Alert>
      )}
      <OpenableFileListItem
        fileName={attachment.name}
        onOpen={openFile}
        isOpening={isOpening}
      />
    </div>
  )
}
